import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20anime%20collage%20with%20warm%20coral%20red%20and%20gold%20amber%20color%20palette%2C%20soft%20gradient%20background%2C%20minimalist%20Japanese%20animation%20inspired%20composition%2C%20geometric%20shapes%20and%20flowing%20lines%2C%20dreamy%20ethereal%20atmosphere%2C%20modern%20art%20style%2C%20no%20text&width=1800&height=900&seq=hero-bg&orientation=landscape"
        alt="好坏动漫 Hero"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 container-site h-full flex flex-col items-center justify-center text-center">
        <p className="text-white/80 text-sm md:text-base tracking-widest uppercase mb-4 font-label">
          {t("home.heroSubtitle")}
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-4 max-w-3xl leading-tight">
          {t("home.heroTitle")}
        </h1>
        <p className="text-white/70 text-sm md:text-lg max-w-xl mb-8 leading-relaxed">
          {t("home.heroDesc")}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-lg">
          <div className="relative flex-1 w-full">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              placeholder={t("home.searchPlaceholder")}
              className="w-full pl-10 pr-4 py-3 rounded-full bg-white/95 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <Link
            to="/category/all"
            className="whitespace-nowrap px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            {t("home.viewMore")}
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-white text-xl md:text-2xl font-bold font-heading">12+</p>
            <p className="text-white/60 text-xs">深度评测</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-white text-xl md:text-2xl font-bold font-heading">8</p>
            <p className="text-white/60 text-xs">分类覆盖</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-white text-xl md:text-2xl font-bold font-heading">500K+</p>
            <p className="text-white/60 text-xs">月访问用户</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}